"use client";

import React, { useEffect } from "react";
import {
  getWeeklyChallenges,
  hasCompletedThisWeek,
} from "@/lib/weeklyChallenges";
import { useAppStore } from "@/store/useAppStore";
import { ChallengeModal } from "./modals/ChallengeModal";
import { BettingModel } from "./modals/BettingModel";
import { WeeklyRefreshNotice } from "./WeeklyRefreshNotice";
import { GameModeSelector } from "./GameModeSelector";
import { ChallengesCards } from "./ChallengesCards";
import { CrowdResultsModal } from "./modals/CrowdResultsModal";

export const QuickChallenges = () => {
  const {
    gameMode,
    completedChallenges,
    setQuickChallenges,
    setAllWeekCompleted,
  } = useAppStore();
  useEffect(() => {
    const challenges = getWeeklyChallenges();
    setQuickChallenges(challenges);

    const completed = hasCompletedThisWeek(completedChallenges);
    setAllWeekCompleted(completed);
  }, [completedChallenges, setQuickChallenges, setAllWeekCompleted]);

  return (
    <div className="max-w-4xl mx-auto px-4 md:px-8 pt-4 pb-24">
      <h2 className="text-3xl font-bold text-center mb-4">
        ⚡ Behavioral Economics Challenges
      </h2>
      <p className="text-center text-gray-300 mb-6">
        Test your brain against Nobel Prize winners Kahneman & Thaler, plus
        decision strategist Annie Duke.
      </p>

      <GameModeSelector />

      {gameMode === "crowd" && (
        <div className="bg-gradient-to-r from-brand-teal/20 to-brand-amber/20 backdrop-blur-xl rounded-xl p-4 mb-6 border border-brand-teal/30">
          <div className="text-center">
            <h3 className="text-lg font-bold text-white mb-2">
              🔥 Beat the Crowd Mode
            </h3>
            <p className="text-sm text-gray-300">
              See how your answers compare to other players. Beat the crowd to
              earn bonus points!
            </p>
          </div>
        </div>
      )}
      <ChallengesCards />
      <WeeklyRefreshNotice />
      <ChallengeModal />
      <BettingModel />
      <CrowdResultsModal />
    </div>
  );
};
